import { Link } from "react-router-dom";
import { trackVisitorEvent, withMarketingQuery } from "../lib/visitorAnalytics";
export default function PublicNav() {
  const onDemo = () => trackVisitorEvent("demo_clicked", { source: "public_nav" });
  const onTrial = () => trackVisitorEvent("trial_started", { source: "public_nav" });

  return (
    <nav className="public-nav" data-testid="public-nav">
      <Link to="/">Product</Link>
      <a href="/#how-it-works">How It Works</a>
      <Link to="/pricing" onClick={() => trackVisitorEvent("pricing_viewed", { source: "nav" })}>Pricing</Link>
      <Link to="/login?demo=1" data-testid="nav-explore-demo" onClick={onDemo}>Explore Demo</Link>
      <Link to="/login" data-testid="nav-sign-in">Sign In</Link>
      <Link
        to={withMarketingQuery("/signup?plan=trial")}
        className="public-nav-cta"
        data-testid="nav-start-trial"
        onClick={onTrial}
      >
        Start Free Trial
      </Link>
    </nav>
  );
}
